export const levelAtConstant = {
  CUSTOMER: 'Customer',
  ACCOUNT: 'Account',
  CAMPAIGN: 'Campaign',
  ADGROUP: 'AdGroup',
  KEYWORD: 'Keyword',
};
